import { Box, Text } from "@chakra-ui/layout";
import { DataTable, LoadingOverlay, ModuleTitle } from "@src/components/ui-kit";
import { Pagination } from "@src/components/ui-kit/table/pagination";
import type { NavigationReportsProps } from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { withCan } from "@src/utils/components/permissions";
import { toApiDate } from "@src/utils/dates";
import { useUpdateURI } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import { useState } from "react";
import { Summary } from "../../common/summary/profit-and-revenue";
import { useFetchTableOptions } from "../common/hooks";
import { TableNavbar } from "../common/TableNavbar";
import { useFetchTableData } from "./hooks";
import { Store, StoreContext } from "./store";
import { Table } from "./Table";

type Props = {
  report: NavigationReportsProps["currentReport"];
};

export const ProjectProfitAndRevenue = withCan(
  { do: ["project_read_own", "project_read_all", "project_read_team"] },
  observer(function ProjectRevenue({ report }: Props) {
    const router = useRouter();

    const [store] = useState(() => {
      const store = new Store();

      store.reportStore.initFilters(router.query);

      return store;
    });

    const [loadingData, fetchingSummary] = useFetchTableData(store);
    const loadingOptions = useFetchTableOptions(store.reportStore);

    useUpdateURI({
      ...store.reportStore.uriParams,
      from: toApiDate(store.reportStore.dateRange.start),
      to: toApiDate(store.reportStore.dateRange.end),
    });

    return (
      <StoreContext.Provider value={store}>
        <Box mb="4">
          <ModuleTitle>
            <Text fontWeight="inherit">{report?.title()}</Text>
          </ModuleTitle>
        </Box>
        <DataTable>
          <TableNavbar store={store.reportStore} />
          <Summary
            summary={store.summary}
            isFetching={fetchingSummary}
            expenseBudgetCategories={store.reportStore.expenseBudgetCategories}
          />
          <LoadingOverlay
            isLoading={loadingData || loadingOptions}
            minH="16"
            position="absolute"
          >
            <Table />
          </LoadingOverlay>
          <Pagination store={store.reportStore.pagination} />
        </DataTable>
      </StoreContext.Provider>
    );
  }),
);
